import {authHeaders, handleResponse} from "./apiUtils";

const baseUrl = process.env.NODE_ENV === "production"
  ? "https://uyygv3wln6.execute-api.eu-west-1.amazonaws.com/default/"
  : "http://localhost:3001/";

function getSettings() {
  return fetch(`${baseUrl}settings`, {
    headers: authHeaders(),
  }).then(handleResponse);
}

function saveSetting(setting) {
  return fetch(`${baseUrl}settings/${setting.id}`, {
    method: "PUT",
    headers: authHeaders({ "content-type": "application/json" }),
    body: JSON.stringify(setting),
  }).then(handleResponse);
}

export default {
  getSettings,
  saveSetting,
};
